import { AdvancedMarker, InfoWindow, useMap } from "@vis.gl/react-google-maps";
import { useState, useEffect, useMemo } from "react";
import InfoWindowContent from "./InfoWindowContent";
import useGetPixelOffset from "../../hooks/useDynamicPixelOffset";
import { useAdvSearch } from "../../providers/advSearchCtx";
import useDynamicPixelOffset from "../../hooks/useDynamicPixelOffset";

function Markers({ markers }) {
  const map = useMap();
  const [zoom, setZoom] = useState(null);

  const [hoveredMarkerId, setHoveredMarkerId] = useState(null);
  const [activeMarkerId, setActiveMarkerId] = useState(null);
  const [activeMarkerPosition, setActiveMarkerPosition] = useState(null);
  const { x, y } = useDynamicPixelOffset(map, activeMarkerPosition);

  useEffect(() => {
    if (!map) return;

    const listener = map.addListener("zoom_changed", () => {
      setZoom(map.getZoom());
    });

    setZoom(map.getZoom());

    return () => listener.remove();
  }, [map]);

  const handleMouseEnter = (id) => setHoveredMarkerId(id);
  const handleMouseLeave = () =>
    setTimeout(() => setHoveredMarkerId(null), 220);

  const handleMarkerClick = (id, position) => {
    setActiveMarkerId(id);
    setActiveMarkerPosition(position);
  };

  return (
    <>
      {markers.map((singleMarker) => {
        const showPrice = zoom >= 13;
        const doShowPriceHover = hoveredMarkerId === singleMarker.id;
        const vendita_privata = singleMarker.vendita_privata;

        let bg = "#BB005F";
        let type = "vendita";

        if (vendita_privata) {
          bg = "#274E9D";
          type = "privati";
        } else if (singleMarker.tipologia_contratto === "affitto") {
          bg = "#88a650";
          type = "affitto";
        }

        const singleMarkerClasses = `uk-animation-slide-top-small single_marker marker_${type}`;

        return (
          <AdvancedMarker
            key={singleMarker.id}
            position={singleMarker.position}
            onMouseEnter={() => handleMouseEnter(singleMarker.id)}
            onMouseLeave={handleMouseLeave}
            onClick={() =>
              handleMarkerClick(singleMarker.id, singleMarker.position)
            }
            zIndex={doShowPriceHover ? 999999 : 1}
          >
            {showPrice || doShowPriceHover ? (
              <div
                className={singleMarkerClasses}
                style={{
                  backgroundColor: bg,
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                  transform: doShowPriceHover ? "scale(1.1)" : "scale(1)",
                  transition: "transform 0.15s ease, z-index 0s",
                }}
              >
                {singleMarker.prezzo > 0
                  ? singleMarker.prezzo + "€"
                  : "su Richiesta"}
                {singleMarker.tipologia_contratto === "vendita" ? "" : "/mese"}
              </div>
            ) : (
              <div
                className="uk-animation-slide-top-small single_marker"
                style={{
                  width: "14px",
                  height: "14px",
                  backgroundColor: bg,
                  borderRadius: "50%",
                  border: "2px solid white",
                  boxShadow: "0 0 4px rgba(0,0,0,0.4)",
                }}
              />
            )}
          </AdvancedMarker>
        );
      })}

      {activeMarkerId && activeMarkerPosition && (
        <>
          <InfoWindow
            position={activeMarkerPosition}
            onCloseClick={() => setActiveMarkerId(null)}
            pixelOffset={[x, y]}
            maxWidth={250}
            disableAutoPan={true}
            className="info-window"
          >
            <InfoWindowContent
              marker={markers.find((m) => m.id === activeMarkerId)}
              className="info-window-content"
            />
          </InfoWindow>
        </>
      )}
    </>
  );
}

export default Markers;
